import { createFileRoute } from '@tanstack/react-router';
import BookingNew from '@/pages/BookingNew';

/**
 * Booking Route (/booking)
 *
 * Office job creation form — creates a Job directly via POST /api/v3/jobs.
 * There is no separate "bookings" entity. "Booking" = creating a job from the office.
 */

export const Route = createFileRoute('/_authenticated/booking')({
  component: BookingNew,
});
